<template>
  <div>
    <InventoryComponent type="0" />
  </div>
</template>
<script>
import InventoryComponent from './InventoryComponent'

export default {
  name: 'MainPage',
  components: {
    InventoryComponent
  },
  data: function () {
    return {
    }
  },
  created () {
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === undefined || this.userInfo === null) {
      this.$router.push('/')
    }
  },
  mounted () {

  },
  updated () {
  },
  methods: {

  }
}
</script>

<style lang="scss">
</style>
